import { VIS_URLS_FETCHED } from "../actions/company";

export default (state = null, action = {}) => {
  switch (action.type) {
    case VIS_URLS_FETCHED:
      return action.payload;
    default:
      return state;
  }
};
